import { IMGS_PATH } from 'constants/image';
import clsx from 'clsx';
import { useState } from 'react';
import ReactSwipe from 'react-swipe';
import { Direction } from 'types/Utilities';
import Icon from 'components/ui/Icon';
import Image from 'components/ui/Image';
import Link from 'components/ui/Link';
import tailwind from 'utils/breakpoints';
import { useTranslation } from 'hooks/useTranslation';

const testimonialEntries = {
  en: [
    {
      text: 'Everything about the process was smooth and professional. The contact in the week leading up to my transplant was excellent and I was confident I knew the full itinerary of my trip. I would definitely recommend smile hair clinic and Qunomedical.',
      name: 'Christopher',
      image: 'profile-christopher',
      location: 'United Kingdom',
      treatment: {
        name: 'Hair Transplant',
        link: 'plastic-surgery/hair-transplant',
      },
      clinic: {
        name: 'Smile Hair Clinic',
        link: 'smile-hair-clinic',
      },
    },
    {
      text: 'I was never pushed or forced into the treatment as most other clinics were doing. Quno was understanding, and genuinely interested in getting the best results for me.',
      name: 'Iwan',
      image: 'profile-iwan',
      location: 'United Kingdom',
      treatment: {
        name: 'Hair Transplant',
        link: 'plastic-surgery/hair-transplant',
      },
      clinic: {},
    },
    {
      text: 'From the moment I contacted Julia at Qunomedical to arriving back home after my hair transplant, the whole experience has been excellent.',
      name: 'Scott',
      image: 'profile-scott',
      location: 'United Kingdom',
      treatment: {
        name: 'Hair Transplant',
        link: 'plastic-surgery/hair-transplant',
      },
      clinic: {
        name: 'Dr. Cinik Hair Hospital',
        link: 'dr-emrah-cinik-clinic',
      },
    },
    {
      text: 'Everything with Quno was perfect. They were a big part in linking me to the best place for me in regards to price and distance to travel.',
      name: 'Shane',
      image: 'profile-shane',
      location: 'Ireland',
      treatment: {
        name: 'Hair Transplant',
        link: 'plastic-surgery/hair-transplant',
      },
      clinic: {
        name: 'MyPerfectHairClinic',
        link: 'my-perfect-hair-clinic',
      },
    },
    {
      text: 'All I can say is I can’t stop smiling and looking in the mirror at my new beautiful teeth. My insecurities have vanished I can smile again with confidence. Thank goodness for the quality of overseas dentistry. ',
      name: 'Taniya',
      image: 'profile-taniya',
      location: 'United Kingdom',
      treatment: {
        name: 'Veneers',
        link: 'dentistry/veneers',
      },
      clinic: {
        name: 'Dentaglobal',
        link: 'dentaglobal',
      },
    },
    {
      text: 'Thank you, for the opportunity for this lifechanging experience, I hope more people can see how great it is.',
      name: 'Haroun',
      image: 'profile-haroun',
      location: 'Ireland',
      treatment: {
        name: 'Gastric Bypass',
        link: 'weight-loss-surgery/gastric-bypass-surgery',
      },
      clinic: {
        name: 'Memorial Bahcelievler',
        link: 'memorial-bahcelievler',
      },
    },
  ],
  de: [
    {
      text: 'Es wurde kein Druck auf mich ausgeübt eine Entscheidung zu treffen, wie es viele andere Kliniken gemacht haben. Quno war verständnisvoll und ehrlich daran interessiert, das beste Ergebnis für mich zu erzielen.',
      name: 'Iwan',
      image: 'profile-iwan',
      location: 'Großbritannien',
      treatment: {
        name: 'Haartransplantation',
        link: 'plastische-chirurgie/haartransplantation',
      },
      clinic: {},
    },
    {
      text: 'Ich persönlich bin zu 100% überrascht. Ab dem ersten Anruf, hatte ich bei Ihr ein gutes Gefühl. Die Beratung war sehr gut. Alle Informationen waren stimmig und es ist alles optimal verlaufen ',
      name: 'Udo',
      image: 'profile-udo',
      location: 'Deutschland',
      treatment: {
        name: 'Haartransplantation',
        link: 'plastische-chirurgie/haartransplantation',
      },
      clinic: {},
    },
    {
      text: 'Von Beginn an war der Ablauf zum einen schnell und reibungslos. Ich habe mehrere Male mit einer sehr netten Mitarbeiterin von Qunomedical telefoniert und alle Fragen wurden unmittelbar beantwortet.',
      name: 'Elina',
      image: 'profile-elina',
      location: 'Deutschland',
      treatment: {
        name: 'Veneers',
        link: 'zahnmedizin/veneers',
      },
      clinic: {},
    },
    {
      text: 'Ich hatte vollstes Vertrauen in die Ärzte und ihr Können. Mit Qunomedical war alles von Anfang bis Ende super easy und unkompliziert.',
      name: 'Matt',
      image: 'profile-matt',
      location: 'Großbritannien',
      treatment: {
        name: 'Haartransplantation',
        link: 'plastische-chirurgie/haartransplantation',
      },
      clinic: {
        name: 'Dr. Ziya Yavuz Clinic',
        link: 'dr-ziya-yavuz-klinik-im-acibadem-kadikoy-krankenhaus',
      },
    },
    {
      text: 'Ich kann gar nicht aufhören zu lächeln und meine schönen neuen Zähne im Spiegel anzuschauen. Meine Unsicherheiten sind weg und ich lache jetzt mit Selbstbewusstsein. Gott sei Dank gibt es im Ausland so gute Zahnärzte.',
      name: 'Taniya',
      image: 'profile-taniya',
      location: 'Großbritannien',
      treatment: {
        name: 'Veneers',
        link: 'zahnmedizin/veneers',
      },
      clinic: {
        name: 'Dentaglobal',
        link: 'dentaglobal',
      },
    },
    {
      text: 'Danke, dass ihr mir die Möglichkeit gegeben habt, mein Leben zu verändern. Hoffentlich können das noch mehr Leute erleben',
      name: 'Haroun',
      image: 'profile-haroun',
      location: 'Irland',
      treatment: {
        name: 'Magenbypass',
        link: 'operative-gewichtsreduktion/magenbypass-operation',
      },
      clinic: {
        name: 'Memorial Bahcelievler',
        link: 'memorial-bahcelievler',
      },
    },
  ],
};

const Testimonials = (): JSX.Element | null => {
  const { locale, t } = useTranslation();
  const [currentSlide, setCurrentSlide] = useState(0);

  let reactSwipeElement: ReactSwipe | null;

  const prev = (): void => {
    reactSwipeElement?.prev();
  };

  const next = (): void => {
    reactSwipeElement?.next();
  };

  const testimonialEntry =
    testimonialEntries[locale as keyof typeof testimonialEntries];

  if (!testimonialEntry) {
    return null;
  }

  return (
    <div className="bg-white lg:-mt-36 pt-12 pb-10 md:py-24 lg:pt-56">
      <div className="max-w-screen-lg mx-auto px-5 md:px-4 relative">
        <div className="lg:flex items-center">
          <Icon
            type="Arrow"
            direction={Direction.LEFT}
            color={tailwind.theme.backgroundColor.tertiary}
            className="shrink-0 hidden lg:block cursor-pointer"
            onClick={prev}
          />
          <div className="max-w-screen-md mx-auto relative pb-12 md:pt-12">
            <ReactSwipe
              swipeOptions={{
                callback: (i) => setCurrentSlide(i),
              }}
              ref={(element) => {
                reactSwipeElement = element;
              }}
            >
              {testimonialEntry.map((entry, i) => (
                <div key={i} className="px-8 md:px-12 relative h-full">
                  <p className="font-bold text-tertiary italic text-4-875r font-netto md:hidden -mb-12 ml-2">
                    &quot;
                  </p>
                  <p className="font-adelle font-bold text-1-313r lg:text-1-75r text-center text-charcoal leading-2-063r lg:leading-12">
                    <span className="font-bold text-tertiary italic text-4-875r font-netto hidden md:inline absolute -ml-16">
                      &quot;
                    </span>
                    {entry.text}
                  </p>
                  <div className="max-w-screen-sm mx-auto mt-12 flex items-center justify-center">
                    <p className="mr-6">
                      <Image
                        src={`${IMGS_PATH.PUBLIC}/${entry.image}.png`}
                        alt={entry.name}
                        height={100}
                        width={100}
                      />
                    </p>
                    <div>
                      <p className="font-bold text-charcoal">
                        {entry.name}, {entry.location}
                      </p>
                      <p className="text-sm font-adelle mt-2 text-charcoal">
                        <Link href={`/${locale}/${entry.treatment.link}`}>
                          <a className="underline" title={entry.treatment.name}>
                            {entry.treatment.name}
                          </a>
                        </Link>{' '}
                        {entry.clinic.name && (
                          <>
                            {t('testimonials.atClinic')}{' '}
                            {entry.clinic.link ? (
                              <Link href={`/${locale}/${entry.clinic.link}`}>
                                <a
                                  className="underline"
                                  title={entry.clinic.name}
                                >
                                  {entry.clinic.name}
                                </a>
                              </Link>
                            ) : (
                              entry.clinic.name
                            )}
                          </>
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </ReactSwipe>
            <div className="flex absolute bottom-0 w-full pb-2 justify-center lg:hidden">
              {[...Array(testimonialEntry.length).keys()].map((_, i) => (
                <div
                  key={i}
                  className={clsx(
                    'w-2 h-2 bg-charcoal rounded-full mx-1',
                    i !== currentSlide && 'opacity-50',
                  )}
                />
              ))}
            </div>
          </div>
          <Icon
            type="Arrow"
            direction={Direction.RIGHT}
            color={tailwind.theme.backgroundColor.tertiary}
            className="shrink-0 hidden lg:block cursor-pointer"
            onClick={next}
          />
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
